module.exports = __webpack_public_path__ + "static/media/pricing4.d21d6e99.png";